module.exports = __webpack_public_path__ + "static/checkmark-c7b49551a13eba6f01cbe0d1e9d303ae.png";